"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AlphabetSoupWithDimensions", {
  enumerable: true,
  get: function get() {
    return _AlphabetSoupWithDimensions.default;
  }
});
exports.default = void 0;

var _AlphabetSoup = _interopRequireDefault(require("./AlphabetSoup"));

var _AlphabetSoupWithDimensions = _interopRequireDefault(require("./AlphabetSoupWithDimensions"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-unresolved */
// there are problems with eslint not able to detect the imports
var _default = _AlphabetSoup.default;
exports.default = _default;